import axios from "axios";
import qs from "qs";

import { State } from "./state";
import { BASE_URL } from "../app/appConstants";
import * as authenticationActions from "./authentication/actions";
import { requestLogout } from "./authentication/thunks";
import { AppDispatch } from "./configureStore";
import keycloak from "../app/authentication/keycloak/keycloak";
import {
  removeSessionCookies,
  setSessionCookies,
} from "../app/authentication/keycloak/KeycloakProvider";

export const isTokenExpired = (error: any): boolean => {
  if (!error || !error.response || !error.response.status) {
    return false;
  }
  return (
    error.response.status === 401 &&
    error.response.data.error === "invalid_token"
  );
};

export const renewAccessToken =
  (retryFn: Function) => (dispatch: AppDispatch, getState: () => State) => {
    const authenticatedWithKeycloak =
      getState().authentication.authenticatedWithKeycloak;

    if (authenticatedWithKeycloak) {
      dispatch(renewAccessTokenKeycloak(retryFn));
    } else {
      dispatch(renewAccessTokenLegacy(retryFn));
    }
  };

const renewAccessTokenKeycloak =
  (retryFn: Function) =>
  async (dispatch: AppDispatch, getState: () => State) => {
    console.log("renewAccessToken keycloak");

    try {
      const refreshed = await keycloak.updateToken(60);

      if (refreshed) {
        const tokenData = {
          accessToken: keycloak.token,
          refreshToken: keycloak.refreshToken,
        };

        setSessionCookies({ ...tokenData });

        dispatch(authenticationActions.setTokens({ ...tokenData }));

        return dispatch(retryFn());
      } else {
        console.warn("Token is still valid");
        return dispatch(retryFn());
      }
    } catch (error) {
      console.error("Failed to refresh token", error);
      keycloak.clearToken();
      removeSessionCookies(true);
      dispatch(
        authenticationActions.loginFailed(
          "There was an issue logging in. Please retry."
        )
      );
      dispatch(requestLogout());
    }
  };

const renewAccessTokenLegacy =
  (retryFn: Function) => (dispatch: AppDispatch, getState: () => State) => {
    const refreshToken = getState().authentication.refreshToken;

    console.log("renewAccessToken legacy");

    if (!refreshToken) {
      return Promise.reject();
    }
    removeSessionCookies(true);

    const basicAuth = window.btoa("web:topsecretweb");

    axios
      .post(
        `${BASE_URL}/oauth/token`,
        qs.stringify({
          grant_type: "refresh_token",
          refresh_token: refreshToken,
        }),
        {
          headers: {
            Authorization: "Basic " + basicAuth,
            accept: "application/json",
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      )
      .then((response) => {
        const accessToken = response.data.access_token;
        const refreshToken = response.data.refresh_token;
        dispatch(
          authenticationActions.setTokens({
            accessToken,
            refreshToken,
          })
        );
        setSessionCookies({ accessToken, refreshToken });
        return dispatch(retryFn());
      })
      .catch((e) => {
        console.log(e);
        dispatch(
          authenticationActions.loginFailed(
            "There was an issue logging in. Please retry."
          )
        );
        dispatch(requestLogout());
      });
  };

export const handleRequestError =
  (retryFn: Function, error: any) => (dispatch: AppDispatch) => {
    if (isTokenExpired(error)) {
      return dispatch(renewAccessToken(retryFn));
    }

    return Promise.reject(error);
  };
